import * as React from 'react';
import { ContractBalancesViewModel } from '@models/Contract';
import ReactTable, { Column } from 'react-table';
import { dateParser } from '@common/dateParser';

interface ContractBalanceTableComponentProperties {
  readonly balancesVM: Array<ContractBalancesViewModel>;
  readonly selectedBalances: Array<ContractBalancesViewModel>;
  toggleRow: (balance: ContractBalancesViewModel) => void;
}

export const ContractBalanceTableComponent = (props: ContractBalanceTableComponentProperties) => {
  const columns: Column[] = [
    {
      id: 'selection',
      accessor: '',
      width: 55,
      Header: 'Select',
      sortable: false,
      Cell: (row: { value: ContractBalancesViewModel }) => {
        return (
          <input
            type="checkbox"
            className="checkbox"
            checked={props.selectedBalances.indexOf(row.value) > -1}
            onChange={() => {
              props.toggleRow(row.value);
            }}
          />
        );
      }
    },
    {
      accessor: 'balanceType.value',
      Header: 'Balance Type',
      sortable: false
    },
    {
      accessor: 'entityId',
      Header: 'ID',
      sortable: false
    },
    {
      accessor: 'amountDue',
      Header: 'Amount Due',
      sortable: false,
      Cell: (row: { value: number }) => '$' + row.value.toFixed(2)
    },
    {
      accessor: 'paymentDate',
      Header: 'Scheduled Payment',
      sortable: false,
      Cell: (row: { value: Date }) => (row.value ? dateParser.parse(row.value).format('MM/DD/YYYY') : '--')
    }
  ];

  return (
    <>
      <div className="row">
        <h2>Outstanding Balances</h2>
        <div className="col-md-12">
          <ReactTable
            onPageChange={() => {
              Array.from(document.getElementsByClassName('rt-tbody')).forEach(element => {
                element.scrollTop = 0;
              });
            }}
            className="-striped -highlight"
            columns={columns}
            data={props.balancesVM}
            defaultPageSize={props.balancesVM.length}
            manual={true}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 text-right">
          <h3>
            Total Outstanding Balance: $
            {props.balancesVM.reduce((sum, current) => sum + current.amountDue, 0).toFixed(2)}
          </h3>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 text-right">
          <h3>
            Total Selected for Payment: $
            {props.selectedBalances.reduce((sum, current) => sum + current.amountDue, 0).toFixed(2)}
          </h3>
        </div>
      </div>
    </>
  );
};



// WEBPACK FOOTER //
// ./src/contract/_components/contract-balances/_components/contract-balance-table.component.tsx